var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overview-layout"},[_c('el-scrollbar',{ref:"scrollbar",class:{
      'overview-layout-content': true,
      'footer-absolute': _vm.footerType === 'fixed',
    }},[_c('div',{staticClass:"wrapper"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }